exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dialog-container .buttons[data-v-5b63120a]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.el-input-number[data-v-5b63120a]{width:100%}.selected-staff[data-v-5b63120a]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;gap:8px}.selected-staff-tag[data-v-5b63120a]{margin:0}", ""]);

// exports
